import { FC } from "react";
import { Button, Spinner } from "react-bootstrap";
import { OperationEnum, StatusEnum } from "../../models/Enums";
import { ResourcesService } from "../../services/ResourcesService";
import { Language } from '../../types/Language';

type SaveButtonProps = {
    status: StatusEnum,
    operation: OperationEnum,
    onSave: Function,
    className?: string,
    lang: Language;
};

export const SaveButton: FC<SaveButtonProps> = ({ status, operation, onSave, className, lang }) =>
    <Button className={`float-end ms-2 ${className || ''}`} variant="outline-success" size='sm' onClick={() => onSave()} disabled={status !== StatusEnum.Idle}>
        {
            status === StatusEnum.Loading && operation === OperationEnum.Saving
            && <Spinner animation="border" variant="primary" as="span" size="sm" role="status" aria-hidden="true">
                <span className="visually-hidden">{ResourcesService.translate('Loading...', lang)}</span>
            </Spinner>
        }
        <i className='bi bi-save'></i>
        {
            (status !== StatusEnum.Loading || operation !== OperationEnum.Saving)
            && <span> {ResourcesService.translate('Save', lang)}</span>
        }
        {
            status === StatusEnum.Loading && operation === OperationEnum.Saving
            && <span> {ResourcesService.translate('Saving', lang)}</span>
        }
    </Button>